import { initTranslation } from "../modules/i18n.js";
import initPage from "../modules/page";
import initGeoIPModal from "../modules/geoip-modal";
import { initCarousels } from "../modules/product-collection";
import "../../scss/brand.scss";

async function initCategoryPage() {
  await initTranslation();
  initPage();
  initGeoIPModal();
  initCarousels();
}

initCategoryPage();
